// Tiny shared state for "a page is loading" feedback: drives the top progress bar
// and the pending look on the sidebar link that was clicked.
import { reactive } from "vue";

export const navState = reactive({ active: false, progress: 0, pendingPath: null });

let trickle = null;
let finishTimer = null;

export function navStart(path) {
  clearInterval(trickle);
  clearTimeout(finishTimer);
  navState.pendingPath = path;
  navState.active = true;
  navState.progress = 8;
  // ease towards 90% so the bar keeps moving while a lazy chunk downloads
  trickle = setInterval(() => {
    navState.progress += (90 - navState.progress) * 0.08;
  }, 200);
}

export function navDone() {
  clearInterval(trickle);
  navState.progress = 100;
  navState.pendingPath = null;
  finishTimer = setTimeout(() => {
    navState.active = false;
    navState.progress = 0;
  }, 250);
}
